import React, { useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { router } from './routes'
import authService from '@services/authService'
import 'simple-line-icons/css/simple-line-icons.css'
import './styles/icons-override.scss'

/**
 * Main Application Component
 *
 * ROUTING & AUTHENTICATION FLOW:
 * ✅ React Router configured with protected routes
 * ✅ Authentication handled by ProtectedRoute component
 * ✅ Navigation managed by React Router
 * ✅ Toast notifications for user feedback
 *
 * Route Structure:
 * - /login - Public authentication page
 * - / - Protected dashboard layout with nested routes
 *   - /dashboard - Main dashboard
 *   - /companies - Company management (Super Admin)
 *   - /users - User management
 *   - /projects - Project management
 *   - And more...
 */
export default function App() {
	useEffect(() => {
		const handleUnauthorized = () => {
			authService.clearAuthData()
			window.location.href = '/login'
		}
		window.addEventListener('auth:unauthorized', handleUnauthorized)
		return () => window.removeEventListener('auth:unauthorized', handleUnauthorized)
	}, [])

	return (
		<>
			{/* React Router Provider */}
			<RouterProvider router={router} />

			{/* Toast Notifications */}
			<Toaster
				position="top-right"
				toastOptions={{
					duration: 4000,
					style: {
						background: '#363636',
						color: '#fff',
					},
					success: {
						duration: 3000,
						iconTheme: {
							primary: '#4ade80',
							secondary: '#fff',
						},
					},
					error: {
						duration: 5000,
						iconTheme: {
							primary: '#ef4444',
							secondary: '#fff',
						},
					},
				}}
			/>
		</>
	)
}


